<mat-card>
<div>
	<b></b>
</div>
<br/>

<mat-card-content *ngIf="showStep=='1'">
<form [formGroup]="form" (ngSubmit)="onSubmit()">
	
	<h2>Show Test Detail For</h2>
	
	<!--<mat-error *ngIf="globalError"> 
	{{globalError}}
	</mat-error>-->
	
	<mat-form-field>
	  <mat-select  formControlName="competitionTypeStr"  placeholder="Competition Type"  (selectionChange)="competitionTypeChange($event.value)" required>
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="ct.name" *ngFor="let ct of competitionTypes">{{ct.description}}</mat-option>
	  </mat-select>
	  <mat-error> Please select Competition Type</mat-error>
	</mat-form-field>
	
	<mat-form-field>
	  <!-- <mat-label>Individual Type</mat-label> -->
	  <mat-select formControlName="subjectTypeStr"  placeholder="Subject Type"  required>
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="st.name" *ngFor="let st of subjectTypes">{{ st.description }}</mat-option>
	  </mat-select>
	  <mat-error> Please select Subject</mat-error>
	</mat-form-field>
	
	<mat-form-field [style.display]="'none'">
	  <!-- <mat-label>Individual Type</mat-label> -->
	  <mat-select formControlName="compitionLanguageStr"  placeholder="Competition Language" >
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="cl.name" *ngFor="let cl of compitionLanguages">{{ cl.description }}</mat-option>
	  </mat-select>
	  <mat-error> Please select Competition Language</mat-error>
	</mat-form-field>
	
	<mat-form-field [style.display]="'none'">
	  <!-- <mat-label>Individual Type</mat-label> -->
	  <mat-select formControlName="testTypeStr"  placeholder="Test Type">
	    <mat-option>Please Select</mat-option>
	    <mat-option [value]="testType.name" *ngFor="let testType of testTypes">{{ testType.description }}</mat-option>
	  </mat-select>
	  <mat-error> Please select Test Type </mat-error>
	</mat-form-field>
</form>
<button mat-raised-button color="primary" [disabled]="!form.valid" *ngIf="!formSubmitAttempt" (click)="onSubmit()">Start</button>
<button mat-button *ngIf="formSubmitAttempt">
	<mat-icon>autorenew</mat-icon>
</button>
<button mat-raised-button color="primary" (click)="clearCompetitionInitData()">Reset</button>


</mat-card-content> 


<mat-card-content *ngIf="showStep=='2'">
	
<div class="col-md-12">
	<table class="table table-responsive table-hover">
		<tr>
			<th>Comp Type</th>
			<th>Subj Type</th>
			<th>Test Date</th>
			<th>Test Status</th>
			<th>&nbsp;</th>
		</tr>
		<tr *ngFor="let item of testRecord">
			<td>{{item.competitionType}}</td>
			<td>{{item.subjectType}}</td>
			<td>{{item.createdDate | date:'yyyy-MM-dd'}}</td>
			<td>{{item.isTestCompleted }}</td>
			
			<td><span *ngIf="this.appData.availablePrivileges.value.VIEW_OTHERS_TEST || this.appData.availablePrivileges.value.VIEW_OTHERS_TEST_WITH_RESULT">
				<!--<a [routerLink]="['/dashboard-test-series',{'p':'x', 'u':item.loginUserId}]">-->
				<!--<a (click)="testResultHistory(item.loginUserId)">-->
				<a (click)="showPreviousTestResult(item.id)">
				<button mat-button>
					<mat-icon>remove_red_eye</mat-icon>
				</button>
				</a>
				</span>&nbsp;
			</td>
			
		</tr>
	</table>
</div>
</mat-card-content>
</mat-card>